import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './GlossaryTerm.css';

const GlossaryTerm = ({ term, definition, type, formula }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [popupStyle, setPopupStyle] = useState({});
  const termRef = useRef(null);

  useEffect(() => {
    if (isHovered && termRef.current) {
      const rect = termRef.current.getBoundingClientRect();
      const popupWidth = 300; // matches CSS width
      
      setPopupStyle({
        left: `${rect.left + (rect.width / 2) - (popupWidth / 2)}px`,
        top: `${rect.top - 10}px`,
        transform: 'translateY(-100%)'
      });
    }
  }, [isHovered]);

  const formattedDefinition = definition
    .replace(/\\n/g, '\n')
    .split('\n')
    .map((line, i, arr) => (
      <React.Fragment key={i}>
        {line}
        {i < arr.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <>
      <span 
        ref={termRef}
        className="glossary-term"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {term}
      </span>
      {isHovered && createPortal(
        <div className="glossary-popup-portal">
          <div className="glossary-popup" style={popupStyle}>
            <div className="glossary-type">{type}</div>
            <div className="glossary-definition">
              {formattedDefinition}
            </div>
            {formula && (
              <div className="glossary-formula">
                <span>Formula:</span> {formula}
              </div>
            )}
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default GlossaryTerm;